import type { ReactNode } from 'react';

import { cn } from '@simplywallst/ui-core/next';
import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';

type Props = {
  children: ReactNode;
  errorType: 'analysis' | 'input';
};

export const RowsError = ({ children, errorType = 'input' }: Props) => {
  return (
    <div
      className="grid grid-cols-[24px_max-content] items-center gap-x0_5"
      role="alert"
    >
      <svg width="24" height="24" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="6" fill="#FFF" />
        <WarningSolid
          className={cn(errorType === 'input' ? 'fill-warning' : 'fill-bad')}
        />
      </svg>
      <span className="text-xs text-solid">{children}</span>
    </div>
  );
};
